import jwtDecode from 'jwt-decode';
import { DEFAULT_TOKEN_NAME } from '../constants';

export function getToken() {
  return sessionStorage.getItem(DEFAULT_TOKEN_NAME);
}

export function getDataFromToken(jwt) {
  let tokenData;
  try {
    tokenData = jwtDecode(jwt);
  } catch (e) {
    return {};
  }

  if (tokenData.account) {
    const {
      account: {
        tenantId,
        id,
        clients,
        surname,
        givenName,
        evoSbUserId,
        username,
        email,
      },
      scope,
    } = tokenData;
    return {
      clients,
      email,
      evoSbUserId,
      givenName,
      id,
      scope,
      surname,
      tenantId,
      username,
    };
  }

  return {};
}



// WEBPACK FOOTER //
// ./src/helpers/tokens.js